export default {
  list: [
    {
      title: 'درصد',
      value: 'PERCENT'
    },
    {
      title: 'مبلغ',
      value: 'AMOUNT'
    }
  ],
  values: {
    PERCENT: 'PERCENT',
    AMOUNT: 'AMOUNT'
  }
};
